export const BRAND_NAME = 'safetensor';
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/Logo.png`;
export const LOGO_ALT = 'safetensor';
export const CARE_EMAIL = 'Care@safetensor.in';
export const SUPPORT_EMAIL = 'support@safetensor.in';
export const SUPPORT_PHONE = '+91 8307718309';
export const WHATSAPP_NUMBER = '918307718309'; // Used in links (wa.me/91...)
export const WHATSAPP_DISPLAY = '+91-8307718309';
export const COMPANY_LEGAL_NAME = 'SafeTenso Pvt. Ltd.';
export const ADDRESS_MAIN = 'Meghanwas, Mahendergarh, Haryana 123029, India';
export const ADDRESS_SECONDARY = 'Meghanwas, Mahendergarh, Haryana 123029, India';
